import { categoryImageMap } from "@/config/constants";

export function categoryImage(title: string, isCover = false): string {
  if (!title) return "";
  const lowerName = title.toLowerCase();
  for (const keyword in categoryImageMap) {
    if (lowerName.includes(keyword)) {
      const filename = categoryImageMap[keyword];
      return isCover ? `/assets/images/covers/${filename}` : `/assets/images/${filename}`;
    }
  }
  return "";
}
